import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useMedia } from "react-use";
import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Col, Row, Space } from "antd";
import {
  CalendarIcon,
  DoubleUserIcon,
  DownloadIcon,
  File01Icon,
  // MessageEyesIcon,
  // PlusIcon,
  UserIcon,
  UserPlusIcon,
} from "assets/icons";
import { USER_TYPE } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import moment from "moment/moment";
import { AuthInfo, getWorkspaceId } from "stores/slices/auth";
import {
  doGetBroadcastListDetail,
  doGetListUpload,
  getBroadcastListDetail,
} from "stores/slices/broadcastList";
import {
  doAddCusomtersToBroadcastList,
  doCreateCustomer,
  doExportCSVCustomersByBroadcastList,
  doGetAllCustomerNotInBroadcastList,
} from "stores/slices/customer";
import {
  getIsRefresh,
  setHeaderTitle,
  setIsRefresh,
} from "stores/slices/layout";

import AppButton from "components/button";
import CustomerTable from "components/customer/customerTable";
import FormInput from "components/forms/components/formInput";
import LoadingProgress from "components/forms/components/loadingProgress";
import ModalForm from "components/forms/components/modalForm";

import AddBroadcastListForm from "../../../components/broadcastList/form/broadcastListForm";

// import TagRecipient from "../broadcast/tagRecipient";
import ImportExistingCustomer from "./ImportExistingCustomer";

const BroadcastListView = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const below768 = useMedia("(max-width: 768px)");

  const [isOpenCustomerForm, setIsOpenCustomerForm] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isData, setIsData] = useState(false);
  const [isOpenFrm, setIsOpenFrm] = useState(false);
  const [broadcastListSelected, setBroadcastListSelected] = useState(null);
  const [isUpload, setIsUpload] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [isImport, setIsImport] = useState(false);
  const [importExisting, setImportExisting] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [optionsCustomer, setOptionsCustomer] = useState([]);
  const [selectedOptionCustomers, setSelectedOptionCustomers] = useState([]);
  const workspaceId = useSelector(getWorkspaceId);
  const authInfo = useSelector(AuthInfo);
  const [listAllCustomer, setListAllCustomer] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [queries, setQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    broadcastListId: params.id,
  });
  const [loadingList, setLoadingList] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [listSelectCustomers, setListSelectCustomers] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [percent, setPercent] = useState(0);
  const [isDone, setIsDone] = useState(false);
  const [isFail, setIsFail] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isOpenModalProgressing, setIsOpenModalProgressing] = useState(false);
  const { state } = location;
  const isRefresh = useSelector(getIsRefresh);
  const defaultImageCustomer = () => <UserOutlined />;
  const broadcastListUpload = useSelector(
    state => state.broadcastList.broadcastListUpload
  );
  console.log("selectedCustomers", selectedCustomers);
  console.log("listSelectCustomers", listSelectCustomers);

  const handleFormatDateLocale = date => {
    const browserLocale = navigator.language;
    let dateLocale;
    if (date) {
      dateLocale = moment(date).utc().locale(browserLocale);
      return `${dateLocale.format("YYYY-MM-DD")} ${dateLocale.format("LT")}`;
    }
  };

  const broadcastListDetail = useSelector(getBroadcastListDetail);
  useEffect(() => {
    dispatch(setHeaderTitle(["customer", "broadcastList"]));
    dispatch(doGetBroadcastListDetail(params.id));
    if (!state?.isDefault) {
      fecthData({
        ...queries,
      });
    }
  }, []);

  useEffect(() => {
    if (broadcastListUpload.length > 0) {
      const request = broadcastListUpload[0];
      handleUploadBroadcastList(request);
    }
  }, [broadcastListUpload]);

  const handleUploadBroadcastList = async data => {
    const { payload } = await dispatch(
      doAddCusomtersToBroadcastList({
        workspaceId: state?.workspaceId,
        broadcastListId: data.broadcastListId,
        createCustomerAndContactRequests: data.list.filter(
          (item, index) => index <= 99 && item
        ),
      })
    );
    if (payload.status === 200) {
      const count = data.count - 1;

      setPercent(
        Math.round(((data.totalCount - count) / data.totalCount) * 100)
      );
      if (count === 0) {
        await dispatch(
          doGetListUpload({
            broadcastListUpload: broadcastListUpload.slice(1),
          })
        );
        setIsDone(true);
      } else {
        let newList = broadcastListUpload;
        newList = newList.map(item => {
          if (item.broadcastListId === data.broadcastListId) {
            item = {
              ...item,
              list: data.list.slice(100),
              count: data.count - 1,
            };
          }
          return item;
        });
        await dispatch(
          doGetListUpload({
            broadcastListUpload: newList,
          })
        );
      }
    } else {
      setIsDone(false);
      setIsFail(true);
    }
  };

  useEffect(() => {
    if (isDone) {
      setTimeout(() => {
        setIsOpenModalProgressing(false);
        setIsDone(false);
        setPercent(0);
        if (location.pathname.split("/")[2] === "broadcast-list") {
          dispatch(setIsRefresh(uuid()));
        }
      }, 1000);
    }
  }, [isDone]);

  useEffect(() => {
    if (isFail) {
      setTimeout(() => {
        setIsDone(false);
        setPercent(0);
        setIsOpenModalProgressing(false);
        if (location.pathname.split("/")[2] === "broadcast-list") {
          dispatch(setIsRefresh(uuid()));
        }
      }, [3000]);
    }
  }, [isFail]);

  useEffect(() => {
    dispatch(doGetBroadcastListDetail(params.id));
  }, [isRefresh]);
  const fecthData = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      broadcastListId: params.id,
    };
    if (totalPages > 0 && totalPages < newRequest.pageNumber) {
      return;
    }
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      newRequest["workspaceId"] = state.workspaceId;
    }
    setLoadingList(true);
    const { payload } = await dispatch(
      doGetAllCustomerNotInBroadcastList(newRequest)
    );
    if (payload && typeof payload !== "string") {
      setListAllCustomer(
        removeDuplicates([
          ...listAllCustomer,
          ...listSelectCustomers,
          ...payload.content,
        ])
      );
      setTotalPages(payload.totalPages);
      setQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) =>
        ind === arr.findIndex(elem => elem.customerId === ele.customerId)
    );
  };
  const removeDuplicateOptions = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };
  useEffect(() => {
    if (listAllCustomer && listAllCustomer?.length > 0) {
      const newOptions = listAllCustomer.map(item => {
        let label = "";
        if (item.firstName && item.lastName) {
          label = `${item.firstName} ${item.lastName}`;
        } else {
          if (item.contact && item.contact.email) {
            label = `${item.contact.email}`;
          } else {
            label = "Unknown";
          }
        }
        if (item.firstName && !item.lastName) {
          label = `${item.firstName} `;
        }
        if (item.lastName && !item.firstName) {
          label = `${item.lastName} `;
        }
        const avatar =
          item.profileImage &&
          item.profileImage !== "null" &&
          item.profileImage !== "" &&
          (item.profileImage.includes(".png") ||
            item.profileImage.includes(".jpg") ||
            item.profileImage.includes(".jpeg"))
            ? `${item.profileImage}`
            : defaultImageCustomer;
        return {
          id: item.customerId,
          label: label,
          phone: item.contact.phoneNumber,
          src: avatar,
        };
      });
      setOptionsCustomer(
        removeDuplicateOptions([...selectedOptionCustomers, ...newOptions])
      );
    } else {
      setOptionsCustomer([]);
    }
  }, [listAllCustomer]);
  const itemsInput = [
    {
      label: "List Name",
      key: "name",
      value: "Marketing",
      icon: <File01Icon />,
      span: 24,
      readOnly: true,
      config: {
        isLeft: true,
        // isWrap: below768 ? false : true,
      },
    },
    {
      label: "Description",
      key: "description",
      value: "For marketing purpose only",
      icon: <UserIcon />,
      span: 24,
      readOnly: true,
      config: {
        isLeft: true,
        // isWrap: below768 ? false : true,
      },
    },
    {
      label: "Last Broadcast",
      key: "lastBroadcastTime",
      value: "22/07/2023 09:15",
      icon: <CalendarIcon />,
      span: 24,
      readOnly: true,
      config: {
        isLeft: true,
        // isWrap: true,
      },
    },
  ];

  useEffect(() => {
    setValues({
      name: broadcastListDetail.name || "",
      description: broadcastListDetail.description || "",
      lastBroadcastTime: broadcastListDetail.lastBroadcastTime
        ? handleFormatDateLocale(broadcastListDetail.lastBroadcastTime)
        : "",
    });
  }, [broadcastListDetail]);
  const BroadcastListForm = useFormik({
    initialValues: {
      name: "",
      description: "",
      lastBroadcastTime: "",
    },
  });
  const { values, setValues } = BroadcastListForm;

  const handleDownloadCustomer = async data => {
    setIsExporting(true);
    await dispatch(
      doExportCSVCustomersByBroadcastList({
        id: data.id,
        fileName: data.name,
        workspaceId: authInfo.type === USER_TYPE.USER ? "" : data.workspace.id,
      })
    );
    setIsExporting(false);
  };

  const handleImportExistingCustomer = async data => {
    if (data.length === 0) {
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
      setIsImporting(true);
      let newList = [];
      newList = data
        .map(item => {
          return listSelectCustomers.find(
            customer => customer.customerId === item.value
          );
        })
        .filter(item => item !== undefined && item)
        .map(customer => {
          return {
            firstName: customer.firstName || "",
            lastName: customer.lastName || "",
            profileImage: customer.profileImage || "",
            phoneNumber: customer.contact.phoneNumber || "",
            email: customer.contact.email || "",
            facebook: customer.contact.facebook || "",
            instagram: customer.contact.instagram || "",
            twitter: customer.contact.twitter || "",
            snapchat: customer.contact.snapchat || "",
            address: customer.contact.address || "",
            timeZone: customer.timeZone || "",
            create_customer_has_custom_field_requests:
              customer.customerHasCustomFields || [],
          };
        });
      const request = {
        broadcastListId: params.id,
        createCustomerAndContactRequests: newList,
      };
      if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
        request["workspaceId"] = state.workspaceId;
      }
      const result = await dispatch(doCreateCustomer(request));
      if (result && result.payload.status === 200) {
        setIsImporting(false);
        // CustomerForm.setFieldValue("list", []);
        setSelectedCustomers([]);
        setListSelectCustomers([]);
        setSelectedOptionCustomers([]);
        setListAllCustomer([]);
        setImportExisting(false);
        dispatch(setIsRefresh(uuid()));
      } else {
        setIsImporting(false);
      }
      // setSelectedCustomers([]);
    }
  };

  const handleScroll = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      queries.pageNumber <= totalPages
    ) {
      fecthData({
        ...queries,
        pageNumber: queries.pageNumber + 1,
      });
    }
  };

  const fetchDataList = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      broadcastListId: params.id,
    };
    if (totalPages > 0 && totalPages < newRequest.pageNumber) {
      return;
    }
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      newRequest["workspaceId"] = state.workspaceId;
    }
    setLoadingList(true);
    const { payload } = await dispatch(
      doGetAllCustomerNotInBroadcastList(newRequest)
    );
    if (payload && typeof payload !== "string") {
      setTotalPages(payload.totalPages);
      setQueries(newRequest);
      const newList = payload.content.map(item => {
        let label = "";
        if (item.firstName && item.lastName) {
          label = `${item.firstName} ${item.lastName}`;
        } else {
          if (item.contact && item.contact.email) {
            label = `${item.contact.email}`;
          } else {
            label = "Unknown";
          }
        }
        if (item.firstName && !item.lastName) {
          label = `${item.firstName} `;
        }
        if (item.lastName && !item.firstName) {
          label = `${item.lastName} `;
        }
        const avatar =
          item.profileImage &&
          item.profileImage !== "null" &&
          item.profileImage !== "" &&
          (item.profileImage.includes(".png") ||
            item.profileImage.includes(".jpg") ||
            item.profileImage.includes(".jpeg"))
            ? `${item.profileImage}`
            : defaultImageCustomer;
        return {
          id: item.customerId,
          label: label,
          phone: item.contact.phoneNumber,
          src: avatar,
          ...item,
        };
      });
      setListAllCustomer(
        removeDuplicates([...listSelectCustomers, ...newList])
      );
      setLoadingList(false);
      return removeDuplicates([...listSelectCustomers, ...newList]);
    }
  };

  const handleChangeValue = value => {
    if (value.length === 0) {
      setSelectedCustomers(value);
    }
    if (value.length > 0 && listAllCustomer.length > 0) {
      const newList = value
        .map(item => {
          const checkValue = listAllCustomer.find(
            customer =>
              customer.customerId === item.value ||
              customer.contact.email === item ||
              `${customer.firstName} ${customer.lastName}` === item
          );
          if (checkValue) {
            setIsEmpty(false);
            return item;
          }
        })
        .filter(item => item !== undefined && item);
      const newList2 = listAllCustomer
        .map(customer => {
          const checkValue = value.find(
            item => item.value === customer.customerId
          );
          if (checkValue) {
            return customer;
          }
        })
        .filter(item => item !== undefined && item);
      const newList3 = optionsCustomer
        .map(customer => {
          const checkValue = value.find(
            item => item.value === customer.customerId
          );
          if (checkValue) {
            return customer;
          }
        })
        .filter(item => item !== undefined && item);
      setSelectedCustomers(newList);
      setListSelectCustomers(newList2);
      setSelectedOptionCustomers(newList3);
      fetchDataList({
        pageNumber: 1,
        pageSize: 10,
      });
    }
  };

  return (
    <div>
      <Row gutter={16}>
        <Col span={below768 ? 24 : 12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "100%",
              padding: "10px",
              border: "1px solid #EEF0F2",
              borderRadius: "10px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <FormInput
              items={itemsInput.map(item => {
                item.label = t(item.label);
                if (item.key) {
                  item.value = getIn(values, item.key);
                }
                return { ...item };
              })}
              form={BroadcastListForm}
              layout={"vertical"}
              style={{ width: "100%" }}
            />
          </div>
        </Col>
        <Col span={below768 ? 24 : 12}>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <Space
                style={{
                  display: "grid",
                  border: "1px solid #EEF0F2",
                  borderRadius: "10px",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <DoubleUserIcon color={"#12B76A"} />
                <p>{t("broadcastList.title.activeCustomers")}</p>
                <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                  {broadcastListDetail.numberOfCustomerActive}
                </p>
              </Space>
            </Col>
            <Col className="gutter-row" span={12}>
              <Space
                style={{
                  display: "grid",
                  border: "1px solid #EEF0F2",
                  borderRadius: "10px",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <DoubleUserIcon color={"#626576"} />
                <p>{t("broadcastList.title.totalCustomers")}</p>
                <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                  {broadcastListDetail.numberOfCustomer}
                </p>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          {/* <AppButton
            label={t("broadcastList.label.viewMessages")}
            icon={<MessageEyesIcon color={"#5162F3"} />}
            color={"primary"}
            varient={"outline"}
            style={{
              color: "#5162F3",
              backgroundColor: "#DCE1FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              marginLeft: "10px",
            }}
            disabled={isExporting}
          /> */}
          <AppButton
            label={t("broadcastList.label.addCustomer")}
            icon={<UserPlusIcon color={"#5162F3"} />}
            color={"primary"}
            varient={"outline"}
            style={{
              color: "#5162F3",
              backgroundColor: "#DCE1FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              marginLeft: "10px",
            }}
            disabled={isExporting}
            onClick={() => {
              setIsOpenCustomerForm(true);
              setIsAdd(true);
            }}
          />
          <AppButton
            label={t("broadcastList.label.exportBroadcastList")}
            icon={<DownloadIcon color={"#5162F3"} />}
            color={"primary"}
            varient={"outline"}
            style={{
              color: "#5162F3",
              backgroundColor: "#DCE1FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              marginLeft: "10px",
            }}
            disabled={isExporting}
            loading={isExporting}
            onClick={() => {
              handleDownloadCustomer(broadcastListDetail);
            }}
          />
          {!state?.isDefault && (
            <AppButton
              label={t("broadcastList.label.importExist")}
              icon={<PlusOutlined color={"#5162F3"} />}
              color={"primary"}
              varient={"outline"}
              style={{
                color: "#5162F3",
                backgroundColor: "#DCE1FF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                marginLeft: "10px",
              }}
              disabled={isExporting}
              onClick={() => {
                // setListAllCustomer([]);
                fecthData({
                  pageNumber: 1,
                  pageSize: 10,
                });
                setImportExisting(true);
              }}
            />
          )}
          <AppButton
            label={t("broadcastList.label.importCSV")}
            icon={<PlusOutlined color={"#5162F3"} />}
            color={"primary"}
            varient={"outline"}
            style={{
              color: "#5162F3",
              backgroundColor: "#DCE1FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              marginLeft: "10px",
            }}
            disabled={isExporting}
            onClick={() => {
              setIsOpenFrm(true);
              setBroadcastListSelected(null);
              setIsUpload(false);
              setIsCreate(false);
              setIsImport(true);
            }}
          />
        </Col>
      </Row>
      <CustomerTable
        isView={true}
        isAdd={isAdd}
        setIsAdd={setIsAdd}
        params={{
          id: params.id,
          broadcastListName: state?.broadcastListName,
          workspaceId: state?.workspaceId || "",
          workspaceName: state?.workspaceName || "",
        }}
        isOpenCustomerForm={isOpenCustomerForm}
        setIsOpenCustomerForm={setIsOpenCustomerForm}
        isDefault={state?.isDefault}
      />
      <ModalForm
        title={
          isCreate
            ? t("broadcastList.title.addNewBroadcastList")
            : t("broadcastList.title.updateBroadcastList")
        }
        onCancel={() => {
          setIsOpenFrm(false);
          setIsData(false);
          setIsImport(false);
        }}
        onSubmit={() => setIsOpenFrm(false)}
        isOpen={isOpenFrm}
        labelSubmit={t("label.save")}
        customWidth={(isCreate && isData) || (isImport && isData) ? 1300 : 700}
        footer={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <AddBroadcastListForm
          onCancel={() => {
            setIsOpenFrm(false);
            setIsCreate(false);
            setIsData(false);
            setIsImport(false);
          }}
          broadcastListSelected={broadcastListSelected}
          isUpload={isUpload}
          setIsUpload={setIsUpload}
          isCreate={isCreate}
          workspaceId={workspaceId || state?.workspaceId}
          workspaceName={state?.workspaceName}
          setIsRefresh={setIsRefresh}
          setIsData={setIsData}
          isViewPage={true}
          isImport={isImport}
          isDefault={state?.isDefault}
          setIsOpenModalProgressing={setIsOpenModalProgressing}
        />
      </ModalForm>
      <ModalForm
        isOpen={importExisting}
        title={t("broadcastList.title.existingCustomer")}
        onCancel={() => {
          setImportExisting(false);
          setListAllCustomer([]);
          setSelectedCustomers([]);
        }}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.cancel")}
            color={"grey"}
            loading={isImporting}
            disabled={isImporting}
            htmlType="button"
            onClick={() => {
              setImportExisting(false);
              setSelectedCustomers([]);
              setListAllCustomer([]);
            }}
            style={{
              marginTop: 10,
            }}
          />,
          <AppButton
            key="submit"
            label={t("button.import")}
            color={"blue"}
            loading={isImporting}
            disabled={isImporting}
            htmlType="button"
            onClick={() => {
              handleImportExistingCustomer(selectedCustomers);
            }}
          />,
        ]}
        customWidth={600}
      >
        <div>
          <ImportExistingCustomer
            fetchDataList={fetchDataList}
            request={queries}
            fetching={loadingList}
            setFetching={setLoadingList}
            options={optionsCustomer}
            setOptions={setOptionsCustomer}
            onChange={handleChangeValue}
            value={selectedCustomers}
            config={{
              handleScroll: handleScroll,
              styleIcon: {
                width: 43,
              },
            }}
            isRequeried={isEmpty}
          />
        </div>
      </ModalForm>
      <ModalForm
        closeIcon={false}
        title={t("title.progressing")}
        isOpen={isOpenModalProgressing}
        onCancel={() => {
          if (isDone) {
            setIsDone(false);
            setPercent(0);
            setIsOpenModalProgressing(false);
          }
        }}
        footer={false}
        maskClosable={false}
      >
        <LoadingProgress percent={percent} status={isFail ? "exception" : ""} />
        {isDone && (
          <div
            style={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: 20,
              color: "#52c41a",
              marginTop: 10,
            }}
          >
            {t("label.done")}
          </div>
        )}
        {!isDone && !isFail && (
          <div
            style={{
              textAlign: "center",
              fontSize: 14,
              marginTop: 10,
            }}
          >
            {t("text.inProgressing")}
          </div>
        )}
        {isFail && !isDone && (
          <div
            style={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: 14,
              color: "#ff4d4f",
              marginTop: 10,
            }}
          >
            {t("text.failImportCustomer")}
          </div>
        )}
      </ModalForm>
    </div>
  );
};

export default BroadcastListView;
